export function flattenSchemaErrors(details: any): any {
  try {
    return Object.keys(details)
      .map((k) => {
        const detail = details[k];

        return typeof detail === 'object' ? flattenSchemaErrors(detail) : detail;
      })
      .join(`\n`);
  } catch (e: any) {
    return e?.message;
  }
}
